﻿if (window.XDomainRequest) {
	jQuery.ajaxTransport(function (s) {
		if (s.crossDomain /*&& s.async*/) {
			if (s.timeout) {
				s.xdrTimeout = s.timeout;
				delete s.timeout;
			}
			var xdr;
			return {
				send: function (_, complete) {
					function callback(status, statusText, response, responseHeaders) {
						xdr.onload = xdr.onerror = xdr.ontimeout = xdr.onprogress = function() { };
						xdr = undefined;

						if (response.text.slice(0, 9) === "ie9error:") {
							var data = JSON.parse(response.text.substring(9));
							status = data.status;
							statusText = data.description;
							response.text = "";
						}

						complete(status, statusText, response, responseHeaders);
					}
					xdr = new XDomainRequest();

					if (s.url.slice(0, 5) === "https" && window.location.protocol === "http:") {
						s.url = s.url.replace("https", "http");
					}

					xdr.open(s.type, s.url);
					xdr.onload = function () {
						callback(200, "OK", {
							text: xdr.responseText
						}, "Content-Type: " + xdr.contentType);
					};
					xdr.onerror = function () {
						callback(500, "General error.");
					};
					xdr.onprogress = function () { };
					if (s.xdrTimeout) {
						xdr.ontimeout = function () {
							callback(0, "timeout");
						};
						xdr.timeout = s.xdrTimeout;
					}
					xdr.send((s.hasContent && s.data) || null);
				},
				abort: function () {
					if (xdr) {
						xdr.onerror = function () { };
						xdr.abort();
					}
				}
			};
		}
	});
}
